import * as React from 'react';
import { be, IndexObject, strapi } from 'models/conent';
import markdownToHtml from 'lib/markdownToHtml'
import Header from 'components/_OldDesign/header';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import { translate } from 'utils/translate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import ModalVideo from 'react-modal-video'
import { useRouter } from 'next/router'
import { NextPageWithLayout } from '@pages/_app';
import OldLayout from '@components/_OldDesign/OldLayout';
import fetchStrapi, { fetchStrapiBySlug } from 'lib/fetchStrapi';
import { Lang, useLocale } from '@components/Contexts/LocaleContext';
import { omitDeep } from 'lodash-omitdeep';

interface Object {
  data: IndexObject[];
}

const Category: NextPageWithLayout<{category:any}> = ({ category }) => {
  const [url, setUrl] = useState(null);
  const [arrays, setArrays] = useState(null);
  const {lang, setLang} = useLocale();
  const [isOpen, setOpen] = useState(false);
  const [playBanner, setPlayBanner] = useState(false);
  const [playIndex, setPlayIndex] = useState(null)

  const router = useRouter()

  useEffect(() => {
    setUrl(window.location.href);
    setLang((localStorage.getItem('lang') ?? 'th') as Lang);
  }, [])

  useEffect(() => {
    const categoryBlog = JSON.parse(JSON.stringify(category == undefined ? null : category))
    const contents = [];
    let first = true;
    if (categoryBlog?.blogs?.find(data => data.id == router.query.videoId)) {
      let videoFirst = categoryBlog?.blogs?.filter( obj => obj.id == router.query.videoId)
      const videoContent = categoryBlog?.blogs?.sort((a, b) => a.id < b.id ? 1 : -1)?.filter( obj => obj.id != router.query.videoId)?.splice(0,2)
      if (videoFirst && videoContent) {
        Array.prototype.push.apply(videoFirst,videoContent);
      }
      videoFirst?.forEach(element => {
        categoryBlog?.blogs?.splice(categoryBlog?.blogs?.findIndex(x => x.id == element.id), 1)
      });
      contents.push(videoFirst)
    }

    while (categoryBlog?.blogs?.length > 0) {
      if (first) {
        contents.push(categoryBlog?.blogs?.sort((a, b) => a.id < b.id ? 1 : -1)?.splice(0, categoryBlog.name === 'Video' ? 3 : 4));
        first = false;
      } else {
        contents.push(categoryBlog?.blogs?.sort((a, b) => a.id < b.id ? 1 : -1)?.splice(0, categoryBlog.name === 'Video' ? 4 : 5));
        first = true;
      }
    }
    setArrays(contents)
  }, [category])
  
  return <>
    <Header
      content={ { content: category?.description, title: category?.name, image: (be + category?.image?.url) } }/>
    <div
      className="w-full h-auto mt-24 sm:mt-20 md:mt-16 xl:mt-10 p-16 2xl:p-20 bg-cover bg-bottom bg-no-repeat"
      style={ { backgroundImage: `url(${ strapi }${ category?.image?.url })` } }>
      <div className="flex flex-col lg:flex-row">
        <div className="w-full md:w-4/5 lg:w-3/5 md:pr-16 mt-16 md:mt-0">
          <h1 className="text-7xl text-white text-left sm:text-4xl md:text-6xl xl:mt-12">
            { category?.name }
          </h1>
          <div
            className="py-12 md:py-10 text-4xl md:text-2xl lg:text-xl 2xl:text-2xl font-light text-left leading-3 text-white wrap-anywhere">
            { category?.description }
          </div>
        </div>
        { category?.name === 'Video' ?
          <div className="w-full lg:w-2/5 order-first lg:order-last relative align-self-center mb-10 sm:mb-12 lg:mb-0">
            <ModalVideo channel="youtube" autoplay isOpen={ isOpen && playBanner }
              videoId={ category?.link }
              onClose={ () => {
                setOpen(false);
                setPlayBanner(false);
              } }/>
            <img
              src={ strapi + category?.videoCover?.url }
              loading="lazy"
              alt={ category?.name }
              className="w-full"
              onClick={ () => setOpen(true) }/>
            {  <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => {
              setOpen(true);
              setPlayBanner(true);
            } }
              className="text-white fa-7x lg:fa-5x absolute absolute-center cursor-pointer"/> }
          </div> : '' }
      </div>
    </div>
    <div className="mx-20 my-40">
      { arrays?.map((list, index) => <span key={ index }>
        { index % 2 === 0 ? <>
          <hr className={ `${ index === 0 ? 'md:hidden' : '' } hidden md:block border-dark-blue my-12` }/>
          { list?.map((blog, i) => <span key={ i }>
            { i === 0 ? <div className="grid grid-cols-1 md:grid-cols-5 mb-10">
              <div className="md:col-span-3 relative">
                <ModalVideo channel="youtube" autoplay
                  isOpen={ isOpen && !playBanner && playIndex?.index === index && playIndex?.id === i }
                  videoId={ blog?.link }
                  onClose={ () => {
                    setOpen(false);
                    setPlayIndex(null);
                  } }/>
                <img className="lg:hidden h-full lg:h-80 lg:object-cover lg:object-center max-h-96 w-full" alt={ blog.title } src={ strapi + blog.imageMobile?.url }/>
                <img className="hidden lg:block h-full lg:h-80 lg:object-cover lg:object-center max-h-96 w-full" alt={ blog.title } src={ strapi + blog.image?.url }/>
                { blog?.name === 'video' ? <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => {
                  setOpen(true);
                  setPlayIndex({ index: index, id: i });
                } }
                  className="text-white fa-7x lg:fa-5x absolute absolute-center cursor-pointer"/> : '' }
              </div>
              <div
                className={ `${ index % 4 === 0 ? 'md:pl-10' : 'order-last md:order-first md:pr-10' } md:col-span-2 flex flex-col justify-between space-y-10 md:space-y-5 mt-12 md:mt-0` }>
                { blog?.name === 'video' ? <div className="text-5xl md:text-3xl lg:text-xl leading-3">{ blog.title }</div>
                  : <Link href={ '/blogs/' + blog.id + '-' + blog.url }>
                    <div className="text-5xl md:text-3xl lg:text-xl cursor-pointer leading-3">{ blog.title }</div>
                  </Link> }
                <div className="text-3xl md:text-xl lg:text-base font-extralight leading-3">{ translate(blog, 'detail', lang) }</div>
                <div className="grid grid-cols-3 align-self-center w-full">
                  <Link href="/issues">
                    <div
                      className="bg-dark-blue border-dark-blue border-2 text-center text-white py-3 md:py-1 cursor-pointer">
                      <span className="text-2xl md:text-lg lg:text-sm">Issues</span>
                    </div>
                  </Link>
                  <Link href="/categories">
                    <div className="col-span-2 border-dark-blue border-2 text-center py-3 md:py-1 cursor-pointer">
                      <span className="text-2xl md:text-lg lg:text-sm underline">Categories</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div> : '' }
          </span>) }
        </> : '' }
        { index % 2 === 0 && list?.length > 1 ? <>
          <hr className="hidden md:block border-dark-blue my-12"/>
          <div
            className={ `grid grid-cols-1 ${ category?.name === 'Video' ? 'md:grid-cols-2' : 'md:grid-cols-3' } gap-10` }>
            { list?.map((blog, i) => <span key={ i } className={ i === 0 ? 'hidden' : '' }>
              { i !== 0 ? <div className="grid grid-cols-1 mb-10">
                <div className="relative">
                  <ModalVideo channel="youtube" autoplay
                    isOpen={ isOpen && !playBanner && playIndex?.index === index && playIndex?.id === i }
                    videoId={ blog?.link }
                    onClose={ () => {
                      setOpen(false);
                      setPlayIndex(null);
                    } }/>
                  <img className={ `lg:hidden w-full h-full max-h-96 ${blog?.name === 'video' ? 'md:h-80' : 'md:h-56'} object-cover` } alt={ blog.title }
                    src={ strapi + blog.imageMobile?.url }/>
                  <img className={ `hidden lg:block w-full h-full max-h-96 ${blog?.name === 'video' ? 'md:h-80' : 'md:h-56'} object-cover` } alt={ blog.title }
                    src={ strapi + blog.image?.url }/>
                  { blog?.name === 'video' ? <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => {
                    setOpen(true);
                    setPlayIndex({ index: index, id: i });
                  } } className="text-white fa-7x lg:fa-5x absolute absolute-center cursor-pointer"/> : '' }
                </div>
                <div className="flex flex-col justify-between space-y-10 md:space-y-5 mt-7">
                  { blog?.name === 'video' ? <div className="text-5xl md:text-3xl lg:text-xl leading-3">{ blog.title }</div>
                    : <Link href={ '/blogs/' + blog.id + '-' + blog.url }>
                      <div className="text-5xl md:text-3xl lg:text-xl cursor-pointer leading-3">{ blog.title }</div>
                    </Link> }
                  <div className="text-3xl md:text-xl lg:text-base font-extralight leading-3">{ translate(blog, 'detail', lang) }</div>
                </div>
              </div> : '' }
            </span>) }
          </div>
        </> : '' }
        { index % 2 !== 0 ? <>
          <hr className="hidden md:block border-dark-blue my-12"/>
          { list?.map((blog, i) => <span key={ i }>
            { i === 0 ? <div className="grid grid-cols-1 md:grid-cols-5 mb-10">
              <div className="md:col-span-3 relative">
                <ModalVideo channel="youtube" autoplay
                  isOpen={ isOpen && !playBanner && playIndex?.index === index && playIndex?.id === i }
                  videoId={ blog?.link }
                  onClose={ () => {
                    setOpen(false);
                    setPlayIndex(null);
                  } }/>
                <img className="lg:hidden h-full lg:h-80 lg:object-cover lg:object-center max-h-96 w-full" alt={ blog.title } src={ strapi + blog.imageMobile?.url }/>
                <img className="hidden lg:block h-full lg:h-80 lg:object-cover lg:object-center max-h-96 w-full" alt={ blog.title } src={ strapi + blog.image?.url }/>
                { blog?.name === 'video' ? <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => {
                  setOpen(true);
                  setPlayIndex({ index: index, id: i });
                } } className="text-white fa-7x lg:fa-5x absolute absolute-center cursor-pointer"/> : '' }
              </div>
              <div className="md:col-span-2 md:pl-10 flex flex-col justify-between space-y-10 md:space-y-5 mt-12 md:mt-0">
                { blog?.name === 'video' ? <div className="text-5xl md:text-3xl lg:text-xl leading-3">{ blog.title }</div>
                  : <Link href={ '/blogs/' + blog.id + '-' + blog.url }>
                    <div className="text-5xl md:text-3xl lg:text-xl cursor-pointer leading-3">{ blog.title }</div>
                  </Link> }
                <div className="text-3xl md:text-xl lg:text-base font-extralight leading-3">{ translate(blog, 'detail', lang) }</div>
                <div className="grid grid-cols-3 align-self-center w-full">
                  <Link href="/issues">
                    <div
                      className="bg-dark-blue border-dark-blue border-2 text-center text-white py-3 md:py-1 cursor-pointer">
                      <span className="text-2xl md:text-lg lg:text-sm">Issues</span>
                    </div>
                  </Link>
                  <Link href="/categories">
                    <div className="col-span-2 border-dark-blue border-2 text-center py-3 md:py-1 cursor-pointer">
                      <span className="text-2xl md:text-lg lg:text-sm underline">Categories</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div> : '' }
            { i === 1 ? <>
              <hr className="hidden md:block border-dark-blue my-12"/>
              <div className="grid grid-cols-1 md:grid-cols-5 mb-10">
                <div
                  className="order-last md:order-first md:col-span-2 md:pr-10 flex flex-col justify-between space-y-10 md:space-y-5 mt-12 md:mt-0">
                  { blog?.name === 'video' ? <div className="text-5xl md:text-3xl lg:text-xl leading-3">{ blog.title }</div>
                    : <Link href={ '/blogs/' + blog.id + '-' + blog.url }>
                      <div className="text-5xl md:text-3xl lg:text-xl cursor-pointer leading-3">{ blog.title }</div>
                    </Link> }
                  <div className="text-3xl md:text-xl lg:text-base font-extralight leading-3">{ translate(blog, 'detail', lang) }</div>
                  <div className="grid grid-cols-3 align-self-center w-full">
                    <Link href="/issues">
                      <div
                        className="bg-dark-blue border-dark-blue border-2 text-center text-white py-3 md:py-1 cursor-pointer">
                        <span className="text-2xl md:text-lg lg:text-sm">Issues</span>
                      </div>
                    </Link>
                    <Link href="/categories">
                      <div className="col-span-2 border-dark-blue border-2 text-center py-3 md:py-1 cursor-pointer">
                        <span className="text-2xl md:text-lg lg:text-sm underline">Categories</span>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="md:col-span-3 relative">
                  <ModalVideo channel="youtube" autoplay
                    isOpen={ isOpen && !playBanner && playIndex?.index === index && playIndex?.id === i }
                    videoId={ blog?.link }
                    onClose={ () => {
                      setOpen(false);
                      setPlayIndex(null);
                    } }/>
                  <img className="lg:hidden md:col-span-3 h-full lg:h-80 lg:object-cover lg:object-center max-h-96 w-full" alt={ blog.title }
                    src={ strapi + blog.imageMobile?.url }/>
                  <img className="hidden lg:block md:col-span-3 h-full lg:h-80 lg:object-cover lg:object-center max-h-96 w-full" alt={ blog.title }
                    src={ strapi + blog.image?.url }/>
                  { blog?.name === 'video' ? <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => {
                    setOpen(true);
                    setPlayIndex({ index: index, id: i });
                  } } className="text-white fa-7x lg:fa-5x absolute absolute-center cursor-pointer"/> : '' }
                </div>
              </div>
            </> : '' }
          </span>) }
        </> : '' }
        { index % 2 !== 0 && list?.length > 2 ? <>
          <hr className="hidden md:block border-dark-blue my-12"/>
          <div
            className={ `grid grid-cols-1 ${ category?.name === 'Video' ? 'md:grid-cols-2' : 'md:grid-cols-3' } gap-10` }>
            { list?.map((blog, i) => <span key={ i } className={ i < 2 ? 'hidden' : '' }>
              { i >= 2 ? <div className="grid grid-cols-1 mb-10">
                <div className="relative">
                  <ModalVideo channel="youtube" autoplay
                    isOpen={ isOpen && !playBanner && playIndex?.index === index && playIndex?.id === i }
                    videoId={ blog?.link }
                    onClose={ () => {
                      setOpen(false);
                      setPlayIndex(null);
                    } }/>
                  <img className={ `lg:hidden w-full h-full max-h-96 ${blog?.name === 'video' ? 'md:h-80' : 'md:h-56'} object-cover` } alt={ blog.title }
                    src={ strapi + blog.imageMobile?.url }/>
                  <img className={ `hidden lg:block w-full h-full max-h-96 ${blog?.name === 'video' ? 'md:h-80' : 'md:h-56'} object-cover` } alt={ blog.title }
                    src={ strapi + blog.image?.url }/>
                  { blog?.name === 'video' ? <FontAwesomeIcon icon={ faPlayCircle } onClick={ () => {
                    setOpen(true);
                    setPlayIndex({ index: index, id: i });
                  } } className="text-white fa-7x lg:fa-5x absolute absolute-center cursor-pointer"/> : '' }
                </div>
                <div className="flex flex-col justify-between space-y-10 md:space-y-5 mt-7">
                  { blog?.name === 'video' ? <div className="text-5xl md:text-3xl lg:text-xl leading-3">{ blog.title }</div>
                    : <Link href={ '/blogs/' + blog.id + '-' + blog.url }>
                      <div className="text-5xl md:text-3xl lg:text-xl cursor-pointer leading-3">{ blog.title }</div>
                    </Link> }
                  <div className="text-3xl md:text-xl lg:text-base font-extralight leading-3">{ translate(blog, 'detail', lang) }</div>
                </div>
              </div> : '' }
            </span>) }
          </div>
        </> : '' }
      </span>) }
    </div>
    {/*<Subscribe/>*/}
  </>
}

export async function getStaticProps({ params, preview = null }) {
  const routeParam = params.id
  let data = await getPreviewCategories(routeParam);
  data = omitDeep(data, ['formats']);
  data.blogs = (data?.blogs ?? []).map((blog) => {
    return omitDeep(blog, ['description', 'descriptionTH', 'categories', 'formats'])
  })

  const categorydata = await markdownToHtml(data || '')
  return {
    props: {
      category: {
        ...data,
        categorydata,
      },
    },
  }
}

export async function getStaticPaths() {
  const allPosts = await getAllCategories()
  return {
    paths: allPosts?.map((category) => `/categories/${ category.id }-${ (category?.name ?? '').trim() }`) || [],
    fallback: true,
  }
}


async function getPreviewCategories(routeParam): Promise<any> {
  try {
    // const response = await fetch(strapi + '/categories/' + id);
    return await fetchStrapiBySlug('/categories', 'name', routeParam, 3)
  } catch (error) {
    return {
      props: {
        data: JSON.stringify(error),
      },
    };
  }
}

async function getAllCategories(): Promise<any> {
  // const response = await fetch(strapi + '/categories');
  return await fetchStrapi('/categories', 1);
}

Category.getLayout = (page: React.ReactElement) => {
  return <OldLayout>{page}</OldLayout>;
};

export default Category;